/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_TitleInputs */

const cs_demands_title = /** @type {(inputs: Demands_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky`)
};

const en_demands_title = /** @type {(inputs: Demands_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demands`)
};

/**
* | output |
* | --- |
* | "Demands" |
*
* @param {Demands_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_title = /** @type {((inputs?: Demands_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_title(inputs)
	return cs_demands_title(inputs)
});